<template>
  <view class="warp" wx:style="{{warpStyle2}}">
    <block wx:if="{{!error}}">
      <text class="rule" wx:style="{{ruleStyle}}" bindtap="gotoLink(signVersion.rule.link)">规则</text>
      <red-packet-sign
        wx:if="{{activityCouponInfo}}"
        config="{{signVersion.redPacket}}"
        btnText="{{btnText}}"
        couponList="{{couponList}}"
        bind:click="getCoupon"
      />
      <sunflower-code
        config="{{signVersion.code}}"
        codeImageUrl="{{sunflowerCodeImage}}"
        hasGetCoupon="{{hasGetCoupon}}"
        bind:savePosterImg="savePosterImg"
      />
      <poster-popup wx:if="{{posterPopup.show}}" popupData="{{posterPopup.data}}" bind:closePosterPopup="closePopup('posterPopup')"/>
      <result-popup  wx:if="{{resultPopup.show}}" popupData="{{resultPopup.data}}" bind:savePoster="resultPopupSavePoster" bind:closeResultPopup="closePopup('resultPopup')"/>
      <view class="footer">
       <res-banner wx:if="{{activityCouponInfo}}" template="{{info.template}}" version="sign-in" />
      </view>
      <view class="notice">- 本活动由滴滴出行推送 -</view>
    </block>
    <error-view wx:else error="{{error}}" message="{{errmsg}}" />
  </view>
  <toast wx:if="{{toast.show}}" icon="{{toast.icon}}" content="{{toast.content}}"/>
</template>

<script>
import mpx, { createComponent } from '@mpxjs/core'
import { props as properties } from './model/props'
import { chapter, initLogin, getEnvParams } from '../../lib/utils'
import store from '../../lib/store'
import couponMixin from '../../lib/mixin/coupon-v3'
import { getStyle } from '../../lib/editor/utils'
import api from '../../lib/service'

import {
  utils,
  sendXspmScan,
  trackEvent,
  saveImg
} from '@didi/webx-js'

createComponent({
  properties,
  mixins: [ couponMixin ],
  data: {
    style: {},
    redPacketConfig: {},
    showResultPage: false,
    toast: {
      show: false,
      icon: 'success',
      content: '',
    },
    sunflowerCodeImage: '', // 太阳花码图片
    posterPopup: {
      show: false,
      posterImageUrl: '', // 海报弹窗图片
    },
    resultPopup: {
      show: false,
      codeImageUrl: '', // 太阳花图片
      rewardList: [], // 券列表
    },
  },
  attached() {
    // 请求首页的太阳花码
    this.getSunflowerCode()
    if (process.env.MODE === 'editor'){
      this.sunflowerCodeImage = 'https://ut-static.udache.com/webx/ut/R5GCWmYKFr_Ko-Ylc80qS.png'
    }
  },
  watch: {
    'userInfo.token': {
      async handler(val) {
        if (!val) {
          return
        }
        if (!this.doingGetCoupon) {
          this.getInitData({ hasLocate: this.initData.hasLocate })
        } else {
          const res = await api.getPosterCheck()
          res.errno === 0 && this.setPosterSaved({
            has_saved_poster: res.data.activity_info.has_saved_poster,
            save_poster_bonus: res.data.activity_info.save_poster_bonus,
          })
        }
      },
      immediate: true,
    },
  },
  computed: {
    signVersion() {
      return this.pageConfig.signVersion
    },
    ruleStyle() {
      return getStyle(this.signVersion.rule.style)
    },
    warpStyle2() {
      if (this.error) {
        return {
          ...getStyle(this.signVersion.index.style),
          backgroundImage: undefined,
        }
      }
      const showFriday = (process.env.MODE === 'editor' && this.signVersion.friday?.mockEnable) || ([ 5,6,0 ].includes(new Date().getDay()) && this.signVersion.friday?.enable)
      if (showFriday) {
        const fridayStyle = this.signVersion.friday?.style || {}
        fridayStyle.backgroundImage = fridayStyle.backgroundImage ||  this.signVersion.index.style.backgroundImage
        return {
          ...getStyle(this.signVersion.index.style),
          ...getStyle(fridayStyle),
        }
      }
      return getStyle(this.signVersion.index.style)
    },
    btnText() {
      return this.hasGetCoupon && this.hasCoupon ? '去打车' : '立即领取'
    },
  },
  methods: {
    ...store.mapMutations([ 'setSignInfo', 'setPosterSaved' ]),
    ...store.mapActions([ 'getInitData' ]),
    getCoupon: utils.debounce(
      async function(e, showLoading = true, wxOauth) {
        showLoading && trackEvent('userteam_ddlm_coupon_bt_ck', '领券页面-按钮-点击')
        if (this.doingGetCoupon || this.toast.show) return
        if (this.hasGetCoupon && this.hasCoupon) {
          return this.toUseCoupon({}, this.signVersion.index)
        }
        this.doingGetCoupon = true
        await initLogin({
          needLogin: true,
          wxOauth: wxOauth !== undefined ? wxOauth : this.info.wxOauth,
          redirectParams: {
            is_back: '1',
          },
        }).catch(e => {
          this.doingGetCoupon = false
          throw e
        })
        trackEvent('userteam_fx_home_bt_ck', '立即领取', {
          bt_text: this.btnText,
          action: 'ljlq',
        })
        showLoading &&
          mpx.showLoading({
            mask: true,
          })
        const envInfo = await getEnvParams(e)
        const res = await api.getCoupon({
          source_from: this.query.source_from || '', // 通过 保存的海报 进入页面
          // 口令
          pwd_type: this.query.pwd_type,
          exchange_pwd: this.query.exchange_pwd,
          env: envInfo,
          req_env: this.curEnv,
          dunion_callback: this.query.dunion_callback || '',
        })
        this.doingGetCoupon = false
        mpx.hideLoading()
        if (res.errno !== 0) {
          mpx.showToast({
            title: res.errmsg,
            icon: 'none',
            mask: true,
          })
        } else {
          this.toast = {
            show: true,
            icon: 'success',
            content: '领券成功\n保存二维码明日再来',
          }
          setTimeout(() => {
            this.toast.show = false
          }, 2500)
          // this.showPopup('resultPopup', {
          //   rewardList: res.data.rewards || [],
          //   codeImageUrl: this.sunflowerCodeImage,
          // })
        }
        this.getSignInfo()
        await this.getRewardList()
        this.hasGetCoupon = true
        sendXspmScan(
          {},
          {
            a: '',
            b: this.info.template,
            c: chapter[this.info.template].toUseBtn,
            d: '',
          }
        )
      },
      800,
      true
    ),
    async getSignInfo() {
      const res = await api.getSignInfo()
      if(res.errno !== 0) {
        return
      }
      this.setSignInfo(res.data.sign_in_infos)
    },
    // 关闭弹窗
    closePopup(type) {
      this[type].show = false
    },
    // 打开弹窗
    showPopup(type, data) {
      this[type].data = data
      this[type].show = true
    },
    async getSunflowerCode() {
      const res = await api.getSunflowerCode({
        req_env: this.curEnv,
      })
      if (res.errno !== 0) {
        return
      }
      this.sunflowerCodeImage = res.data.code_link
    },
    resultPopupSavePoster() {
      this.closePopup('resultPopup')
      this.savePosterImg()
    },
    // 保存海报图片
    // 微信直接保存海报，h5打开海报弹窗用户长按保存
    async savePosterImg(e) {
      mpx.showLoading({ mask: true })
      const envInfo = await getEnvParams(e)
      const res = await api.getPosterImage({ env: envInfo, req_env: this.curEnv })
      mpx.hideLoading({ mask: true })
      if (res.errno !== 0) {
        return mpx.showToast({
          icon: 'none',
          title: res.errmsg,
        })
      }
      if (__mpx_mode__ === 'wx') {
        saveImg(res.data.poster_link).catch(() => {
            mpx.showToast({
            title: '保存失败',
            icon: 'none',
            duration: 2000,
          })
        })
      }
      this.showPopup('posterPopup', { posterImageUrl: res.data.poster_link, hasBonus: !this.initData.activity_info.has_saved_poster && this.initData.activity_info.save_poster_bonus > 0 })
      this.setPosterSaved({ has_saved_poster: true })
    },
  },
})
</script>

<style lang="stylus" scoped>
// 0123456789.¥
@font-face {
  font-family: DIN-BlackItalic-self
  src: url('https://dpubstatic.udache.com/static/dpubimg/AXmjyhbZbCBZvHajSpoVQ.ttf')
}
// 元折去打车周一二三四五六日可领券包立即取每天都能领打车神券保存海报 !  明天再领 !  每天可领 !打车前必领！!
@font-face {
  font-family: MF-YuanHei-Regular-self
  src: url('https://dpubstatic.udache.com/static/dpubimg/c5UtBlWU-9WDlUg5N-xne.ttf')
}
@font-face {
  font-family: UniSansHeavyCapsItalic-self
  src: url('https://dpubstatic.udache.com/static/dpubimg/d6b47ca2-a4d2-4f84-8864-9040aa6965b5.otf')
}
// 周五六日低至折
@font-face {
  font-family: AlibabaPuHuiTi-Heavy-self
  src: url('https://dpubstatic.udache.com/static/dpubimg/dhnzXchaoOlA3jZz6rsxq.ttf')
}
  .warp
    min-height 100vh
    width 100vw
    overflow hidden
    box-sizing: border-box;
    background-size 100vw auto
    background-repeat no-repeat
    line-height: normal;
    position relative
    .rule
      box-sizing border-box
      position absolute
      right -1px
      z-index 2
      font-family: PingFangSC-Medium;
      background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 0%, rgba(255,238,172,0.48) 100%);
      border-radius: 22.5rpx 0px 0px 22.5rpx
      font-size: 24rpx;
      letter-spacing: 2.67rpx;
      font-weight: bold
      height 40rpx
      line-height 40rpx
      padding 0 14rpx 0 22rpx
      border 1px solid rgba(255, 248, 218, .55)
    .footer
      padding 6rpx 0 177rpx
      background-image: linear-gradient(180deg, #FEE4BF 0%, #FFF5E4 100%);
    .notice
      position absolute
      bottom 30rpx
      left 50%
      transform translateX(-50%)
      font-family: PingFangSC-Regular;
      font-size: 20rpx;
      color: #5A5A5A;
</style>

<script type="application/json">
{
  "component": true,
  "usingComponents": {
    "red-packet-sign": "../../components/wyc/red-packet-sign.mpx",
    "res-banner": "../../components/common/res-banner.mpx",
    "error-view": "../../components/common/error-view.mpx?async=error-view",
    "toast": "../../components/common/toast.mpx",
    "sunflower-code": "../../components/wyc/sunflower-code.mpx",
    "poster-popup": "../../components/wyc/popup/poster-popup.mpx",
    // "result-popup": "../../components/wyc/popup/result-popup.mpx",
  }
}
</script>
